import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  id: 1,
  name: '',
  logo: '',
  menus: [],
  matters: [],
  direccion_completa: '',
  code: '',
  business_hours: null,
  cafeteria_hours: null,
  telefono: '',
  email: '',
  redes_sociales: {},
  apps_urls: {},
  favicon: '',
  data: null,
  descripcion_pub: '',
  paypal_sandbox: null,
  paypal_production: null,
  latitude: '',
  longitude: '',
  pais: '',
  localidad: '',
  has_slider: false,
  has_events: false,
  has_blog: false,
  has_subscription: false,
  theme: '',
  claimsText: '',
  refundText: '',
  fiscal_name: null,
  colour: '#000000',
  direccion: '',
  have_import_orders: false,
  merchant_code: '999008881',
  terminal: '1',
  cancel_order_instead_delete: false,
  store_photo: null,
  is_single_company: false,
  web_url: '',
  slug: '',
  brandLogo: '',
  languages: [
    {
      code_iso2: 'es',
      nombre: 'Español',
    },
    {
      code_iso2: 'en',
      nombre: 'Inglés',
    },
    {
      code_iso2: 'fr',
      nombre: 'Francés',
    },
    {
      code_iso2: 'ca',
      nombre: 'Catalán',
    },
    {
      code_iso2: 'eu',
      nombre: 'Euskera',
    },
    {
      code_iso2: 'gl',
      nombre: 'Gallego',
    }
  ],
  faqsTotals: [],
  mainLists: [],
  shipping_cost: 3.80,
  min_purchase_for_free_shipping: null,
  enabled_countries: [],
  home_url: '',
  home_image: '',
};

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    loadMetaCompany: (state, action) => {
      const {
        id,
        name,
        logo,
        menu_json,
        matters,
        direccion_completa,
        code,
        business_hours,
        cafeteria_hours,
        telefono,
        email,
        redes_sociales,
        apps_urls,
        favicon,
        data,
        descripcion_pub,
        paypal_sandbox,
        paypal_production,
        latitude,
        longitude,
        pais,
        localidad,
        has_slider,
        has_events,
        has_blog,
        has_subscription,
        theme,
        claimsText,
        refundText,
        fiscal_name,
        colour,
        direccion,
        have_import_orders,
        merchant_code,
        terminal,
        cancel_order_instead_delete,
        store_photo,
        web_url,
        slug,
        languages,
        shipping_cost,
        min_purchase_for_free_shipping,
        enabled_countries,
        is_single_company,
        home_url,
        home_image
      } = action.payload;

      state.id = id;
      state.name = name;
      state.logo = logo;
      state.menus = menu_json;
      state.matters = matters;
      state.direccion_completa = direccion_completa;
      state.code = code;
      state.business_hours = business_hours;
      state.cafeteria_hours = cafeteria_hours;
      state.telefono = telefono;
      state.email = email;
      state.redes_sociales = redes_sociales;
      state.apps_urls = apps_urls;
      state.favicon = favicon;
      state.data = data;
      state.descripcion_pub = descripcion_pub;
      state.paypal_sandbox = paypal_sandbox;
      state.paypal_production = paypal_production;
      state.latitude = latitude;
      state.longitude = longitude;
      state.pais = pais;
      state.localidad = localidad;
      state.has_slider = has_slider;
      state.has_events = has_events;
      state.has_blog = has_blog;
      state.has_subscription = has_subscription;
      state.theme = theme;
      state.claimsText = claimsText;
      state.refundText = refundText;
      state.fiscal_name = fiscal_name;
      state.colour = colour;
      state.direccion = direccion;
      state.have_import_orders = have_import_orders;
      state.merchant_code = merchant_code;
      state.terminal = terminal;
      state.cancel_order_instead_delete = cancel_order_instead_delete;
      state.store_photo = store_photo;
      state.web_url = web_url;
      state.slug = slug;
      state.languages = Object.values(languages);
      state.shipping_cost = shipping_cost;
      state.min_purchase_for_free_shipping = min_purchase_for_free_shipping;
      state.enabled_countries = enabled_countries.map((item) => ({
        value: item.codigo,
        label: item.nombre,
      }));
      state.is_single_company = is_single_company;
      state.home_url = home_url;
      state.home_image = home_image;
    },
    setMainLists: (state, action) => {
      state.mainLists = action.payload;
    },
    setFaqsTotals: (state, action) => {
      state.faqsTotals = action.payload;
    },
  },
});

export const { loadMetaCompany, setMainLists, setFaqsTotals } = companySlice.actions;
export const companySelector = (state) => state.company;
export default companySlice.reducer;
